import React from 'react';
import axios from '../utils/axios';

const AuthContext = React.createContext({ user: null, initializing: true });

export const AuthProvider = ({ children }) => {
  const [user, setUser] = React.useState(null);
  const [initializing, setInitializing] = React.useState(true);

  const initAuth = React.useCallback(() => {
    const storageAuth = localStorage.getItem('izya_auth');
    setUser(storageAuth ? { username: 'admin' } : null);
    setInitializing(false);
  }, []);

  const signIn = async (email, password) => {
    const { data } = await axios.post('/v1/admin/auth/signin', {
      email,
      password
    });
    setUser({ username: 'admin' });
    localStorage.setItem('izya_auth', JSON.stringify(data));
  };

  const signOut = () => {
    localStorage.removeItem('izya_auth');
    window.location.replace('/signin');
  };

  React.useEffect(() => {
    initAuth();
  }, [initAuth]);

  const value = React.useMemo(
    () => ({
      user,
      setUser,
      signIn,
      isAuth: !!user,
      initializing,
      initAuth,
      signOut
    }),
    [user, initializing, initAuth]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => React.useContext(AuthContext);
